export interface IDictionaryValue {
  code: string;
  name: string;
  /** код типа сравочника(enum code) */
  typeCode: string;
}
